"use client";

import { signIn } from "next-auth/react";
import { useState } from "react";
import { useRouter } from "next/navigation";

export default function LoginPage() {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    const result = await signIn("credentials", { email, password, redirect: false });
    if (result?.error) {
      setError("Неверный email или пароль");
      return;
    }
    router.push("/projects");
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <form onSubmit={handleSubmit} className="w-80 space-y-4 rounded border border-white/10 bg-white/5 p-8">
        <h1 className="font-display text-2xl uppercase text-foreground">
          Filmway<span className="text-signal-red">.ai</span>
        </h1>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded border border-white/10 bg-background p-2 text-foreground placeholder:text-muted-gray"
          required
        />
        <input
          type="password"
          placeholder="Пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full rounded border border-white/10 bg-background p-2 text-foreground placeholder:text-muted-gray"
          required
        />
        {error && <p className="text-sm text-signal-red">{error}</p>}
        <button type="submit" className="w-full rounded bg-signal-red p-2 uppercase tracking-wide text-white hover:opacity-90">
          Войти
        </button>
      </form>
    </div>
  );
}
